import React from 'react'
import { SxProps } from '@mui/material'

import { useParams } from 'utils/hooks'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import NavigationItem from 'components_new/molecules/NavigationItem'

interface ReportNavigationProps {
  sx?: SxProps
}

const ReportNavigation = (props: ReportNavigationProps) => {
  const { sx } = props
  const { t } = useTranslation()
  const { id } = useParams<{ id: string }>()

  /*-- $TODO: after first release --*/
  // const report = useReport(id)
  // const { isAdmin } = useAccountSettings()
  // const disabled = !report || !isAdmin

  return (
    <>
      <Box sx={sx}>
        <NavigationItem
          item={{
            activePattern: `/reports/${id}`,
            href: `/reports/${id}`,
            icon: { name: 'Image' },
            title: t('global', 'overview')
          }}
        />
        <NavigationItem
          item={{
            activePattern: `/reports/${id}/editions*`,
            href: `/reports/${id}/editions`,
            icon: { name: 'Published' },
            title: t('global', 'editions')
          }}
        />
        {/*-- $TODO: after first release --*/}
        {/* <NavigationItem
          item={{
            activePattern: `/reports/${id}/settings*`,
            disabled: disabled,
            href: `/reports/${id}/settings`,
            icon: { name: 'Settings' },
            title: t('global', 'settings')
          }}
        /> */}
      </Box>
    </>
  )
}

export default ReportNavigation
